module.exports = __webpack_public_path__ + "img/ico-search.59c99ebf.svg";